module.exports = __webpack_public_path__ + "img/nova-aba-aberta.f20d9801.png";